module.exports = __webpack_public_path__ + "img/40_38_061_820.407db3b9.jpg";